import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { SelectInputComponent } from '../../../select-input/select-input.component';
import { ModalitesService, Modalite } from 'src/app/core/modalites.service';
import { FormulaireService } from 'src/app/saisie/formulaire.service';
import { LibellesService } from 'src/app/core/libelles.service';
import { UntypedFormControl } from '@angular/forms';
import { FiltreService } from 'src/app/shared/filtre.service';
import { Subscription } from 'rxjs';
import { ModeRenduService } from 'src/app/saisie/mode-rendu/mode-rendu.service';

/**
 * Composant pour gérer une liste de modalité affectée à une variable.
 * Optimisé pour les enquêtes décisions. On utilise pas HTML5 ici.
 */
@Component({
  selector: 'bis-commune-input-keypad',
  templateUrl: './commune-input-keypad.component.html',
  styleUrls: ['../../../input/input.component.css']
})
export class CommuneInputKeypadComponent extends SelectInputComponent implements OnInit, OnDestroy {
  /**
   * Code devant être affecté si rien n’est saisi apris le passage sur le composant
   */
  @Input() valeurParDefaut = '';
  /**
   * Permet d’afficher ou non le code des modalités.
   * Par défaut à true
   */
  @Input() montreCode = true;
  /** Nombre de choix à montrer*/
  @Input() nbChoixVisiblePossible = 5;
  /** Affiche-t-on les options possibles */
  cacheOptions = true;
  /** choix en cours */
  choixIndexMenu = -1;
  /** Liste contenant les modalités à afficher */
  modalitesFiltrees: Modalite[] = [];

  constructor(
      protected modalitesService: ModalitesService,
      protected formulaireService: FormulaireService,
      protected libelleService: LibellesService,
      protected filtreService: FiltreService,
      public modeRenduService: ModeRenduService
    ) {
      super(modalitesService, formulaireService, libelleService, filtreService, modeRenduService);
    }
    private subModalite: Subscription;
    private subFiltreValueChanges: Subscription;
    private subFormControlValueChanges: Subscription;

  ngOnDestroy(): void {
      super.ngOnDestroy();
      if (this.subModalite) {
        this.subModalite.unsubscribe();
      }
      if (this.subFiltreValueChanges) {
        this.subFiltreValueChanges.unsubscribe();
      }
      if (this.subFormControlValueChanges) {
        this.subFormControlValueChanges.unsubscribe();
      }
  }

  ngOnInit() {
    super.ngOnInit();
    // ajout d’un control au FormGroup pour gérer la saisie en cours
    this.rootForm.setControl(this.label + '_filtre_valeur', new UntypedFormControl(''));
    // ajout d’un listener sur ce control pour mettre à jour la liste des modalités à afficher
    this.subFiltreValueChanges = this.filtreControl.valueChanges.subscribe((filtre) => this.miseAJourListeFiltree(filtre));
    // mise à jour du champ input visible lorsque l’on reçoit la saisie
    this.subFormControlValueChanges = this.currentControl.valueChanges.subscribe((nouveauCode) => {
      this.miseAJourChampVisible(nouveauCode);
    });
    this.currentControl.updateValueAndValidity();
  }

  /**
   * Permet de mettre à jour le champ filtre affiché et visible par l’utilisateur en utilisant une vraie valeur libellé de modalité
   * @param code Code de la modalité
   */
  private miseAJourChampVisible (code: string): void {
    // Vérification qu'il y a bien un code actuellement dans la variable. Sinon il est à null et on efface donc l'affichage
    if (code) {
      // On vérifie dans l'ensemble des modalités reçues par le WS
      this.modalitesService.getCommune(null, code).subscribe((modalite) => {
          if (modalite.length === 1) {
            this.filtreControl.setValue(modalite[0].libelle);
            this.cacheOptions = true;
          }
        });
    } else {
          this.filtreControl.setValue(null);
    }

  }

  /**
   * Permet de mettre à jour modalitesFiltrees en tenant compte d’un filtre.
   * @param filtre chaîne de caractère permettant de sélectionner ce que l’on affiche comme modalités
   */
  private miseAJourListeFiltree(filtre: string): void {
    // Gestion du filtre vide
    if (! filtre) {
      this.modalitesFiltrees = [];
    } else if (filtre.length >= 3) {
        this.modalitesService.getCommune(filtre, null).subscribe((modalites) => {
            this.modalitesFiltrees = modalites;
            if (this.modalitesFiltrees.length === 0) {
                // Comme une modification a eu lieu, il faut refaire valider le choix :
                this.currentControl.setValue('');
                this.cacheOptions = false;
            }
            // Si le choix menu est à -1, on le passe à zéro (modif)
            if (this.choixIndexMenu === -1) {
                this.choixIndexMenu = 0;
            }
        });
    } else {
        this.modalitesFiltrees = [];
    }

  }
  /**
   * Lorsque l’input est séléctionné, on affiche les options possibles
   * @param event Événement
   */
  public onFocusInput(event) {
    // On affiche que si aucun choix n’est déjà validé et si le composant n’est pas en lecture seule
    if (! this.modaliteDejaSaisie && ! this.enLectureSeule) {
      this.cacheOptions = false;
    }
  }
  /**
   * Permet de gérer le clavier pour naviguer entre les options
   * @param event Évenement
   */
  public onKeyupInput(event) {
    if (!this.enLectureSeule) {
      if (event.keyCode === 40) {
        // Touche vers le bas
        this.choixMenu(this.choixIndexMenu + 1);
      } else if (event.keyCode === 38) {
        // Touche vers le haut
        this.choixMenu(this.choixIndexMenu - 1);
      } else if (event.keyCode === 13) {
        // Cas de la touche entrée
        // Si rien n’a été tapé ou modifié
        if (this.choixIndexMenu === -1 && !this.filtreEnCoursSaisie) {
          this.currentControl.setValue(this.valeurParDefaut);
        } else {
          this.choixModalite(this.choixIndexMenu);
        }
      } else if (event.keyCode === 8) {
        if (this.currentControl.value && this.currentControl.value !== '') {
          this.reinitFiltre();
        }
      }/* else {
      if (this.modalitesFiltrees.length >= 1 && this.modalitesFiltrees[0].libelle !== this.filtreControl.value) {
        // Comme une modification a eu lieu, il faut refaire valider le choix :
        this.currentControl.setValue('');
        this.cacheOptions = false;
      }
    }*/
    }

  }
  public onBlurInput(event) {
    // S’il n’y a plus qu’un choix, lors du blur on le choisit
    if (this.modalitesFiltrees.length === 1) {
      this.choixModalite(0);
    }
    // On choisit le choix en cours
    this.choixModalite(this.choixIndexMenu);
  }
  /**
   * Permet de valider l’une des options via son numéro (en commençant par zéro)
   * @var index choix en cours
   */
  public choixModalite(index?: number): void {
    if (!index) {
      index = this.choixIndexMenu;
    }
    // Le choix est-il possible ?
    if (index > -1 && index < this.modalitesFiltrees.length) {
      // Mise à jour de la valeur du controle
      this.currentControl.setValue(this.modalitesFiltrees[index].code);
    }
    // On cache le choix des options
    this.cacheOptions = true;
  }
  /**
   * Permet de choisir l’une des options via son numéro (en commençant par zéro)
   * @var index choix en cours
   */
  public choixMenu (index: number): void {
    // On reste avec un choix positif
    if (index < 0) { index = this.min(this.nbChoixVisiblePossible, this.modalitesFiltrees.length - 1); }
    // On réalise un modulo pour revenir à zéro si plus de choix
    this.choixIndexMenu = (index % (this.modalitesFiltrees.length)) % this.nbChoixVisiblePossible;
    // this.logger.log('Choix du menu : ' + this.choixIndexMenu, 'FilteredSelectInputKeypad');
  }
  /**
   * Retourne le contrôle servant uniquement pour rechercher et montrer le choix effectué dans ce composant
   */
  get filtreControl() {
    return this.rootForm.get(this.label + '_filtre_valeur');
  }
  /**
   * Fonction permettant d’avoir le minimum de deux nombres
   * @param a nombre
   * @param b nombre
   */
  private min(a: number, b: number): number {
    if (a > b) {
      return b;
    } else {
      return a;
    }
  }
  public reinitFiltre(): void {
    this.currentControl.setValue('');
    this.filtreControl.setValue('');
    this.cacheOptions = false;
    // Réinitialisation du choix du menu
    this.choixIndexMenu = -1;
  }
  /**
   * Donne le focus au champ texte du filtre
   */
  public focusInput(): void {
    document.getElementById(`input-select-${this.idHtml}`).focus();
  }
  /**
   * Action lorsque la croix est cliquée
   */
  public cliqueSupprimer(): void {
    if (!this.enLectureSeule) {
      this.reinitFiltre(); this.focusInput();
    }
  }
  get filtreEnCoursSaisie(): boolean {
    return this.filtreControl && this.filtreControl.value !== '' && this.filtreControl.value !== null;

  }
  get modaliteDejaSaisie(): boolean {
    return this.currentControl.value !== null && this.currentControl.value !== '';
  }
  /**
   * Permet de savoir si l’on doit afficher les flèches pour ouvrir ou fermer le menu
   */
  get utileAfficherListe(): boolean {
    return this.currentControl.invalid || this.currentControl.value === '';
  }

  public testMouseOut(event): void {
    this.cacheOptions = true;
  }
}
